import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE = '';

/**
 * Fires a page_view event to the analytics backend on every route change.
 * Fire-and-forget — never blocks UI.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('suryaiq_token');
    if (!token) return;

    fetch(`${BASE}/api/analytics/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        event_type: 'page_view',
        page: location.pathname,
        event_data: '',
      }),
    }).catch(() => {});
  }, [location.pathname]);
}
